export default {
  names: {
    email: 'E-mail',
    password: 'Password',
    confirmPassword: 'Confirm password',
    firstName: 'First Name',
    lastName: 'Last Name',
    newEmail: 'New Email',
    confirmEmail: 'Confirm New Email',
    newPassword: 'New Password'
  }
}
